/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Password_PolicyInputs */



/**
* | output |
* | --- |
* | "Password must be at least 10 characters and include uppercase, lowercase, a number, and a symbol" |
*
* @param {Login_Error_Password_PolicyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_password_policy = /** @type {((inputs?: Login_Error_Password_PolicyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Password_PolicyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le mot de passe doit contenir au moins 10 caractères, avec des majuscules, des minuscules, un chiffre et un symbole")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Passwort muss mindestens 10 Zeichen lang sein und Großbuchstaben, Kleinbuchstaben, eine Zahl und ein Symbol enthalten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La password deve contenere almeno 10 caratteri, con maiuscole, minuscole, un numero e un simbolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пароль должен содержать не менее 10 символов, включая заглавные и строчные буквы, цифру и символ.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La contraseña debe tener al menos 10 caracteres e incluir mayúsculas, minúsculas, un número y un símbolo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("密码必须至少 10 个字符，并包含大写字母、小写字母、数字和符号。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パスワードは10文字以上で、大文字・小文字・数字・記号を含める必要があります")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पासवर्ड कम से कम 10 अक्षरों का होना चाहिए और उसमें बड़े अक्षर, छोटे अक्षर, एक अंक और एक प्रतीक होना चाहिए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A senha deve ter pelo menos 10 caracteres e incluir maiúsculas, minúsculas, um número e um símbolo.")
	return /** @type {LocalizedString} */ ("Password must be at least 10 characters and include uppercase, lowercase, a number, and a symbol")
});